module.exports = __webpack_public_path__ + "img/profile-pic.b86792d2.jpg";